import React from "react";
import { useSnapshot } from "valtio";
import { tattoo } from "../state";

export default function ProjectNameField({ readOnly = false }) {
  const snap = useSnapshot(tattoo);
  const value =
    (
      snap.projectName ||
      snap.meta?.name ||
      snap.fileName ||
      "Untitled"
    ).trim?.() || "Untitled";

  if (readOnly) {
    return (
      <div
        style={{
          marginBottom: 10,
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <label
          style={{
            fontSize: 11,
            textTransform: "uppercase",
            letterSpacing: "0.12em",
            color: "#a1a1aa",
          }}
        >
          Project name
        </label>
        <div
          style={{
            width: "100%",
            padding: "8px 10px",
            borderRadius: 8,
            border: "1px solid #333",
            backgroundColor: "#141414",
            color: "#f9fafb",
            fontSize: 13,
            opacity: 0.9,
          }}
          title={value}
        >
          {value}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        marginBottom: 10,
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <label
        style={{
          fontSize: 11,
          textTransform: "uppercase",
          letterSpacing: "0.12em",
          color: "#a1a1aa",
        }}
      >
        Project name
      </label>
      <input
        type="text"
        value={snap.projectName || ""}
        placeholder="Untitled"
        onChange={(e) => (tattoo.projectName = e.target.value)}
        onBlur={(e) => {
          const trimmed = (e.target.value || "").trim();
          tattoo.projectName = trimmed || "Untitled";
        }}
        style={{
          width: "100%",
          padding: "7px 10px",
          borderRadius: 8,
          border: "1px solid #333",
          backgroundColor: "#141414",
          color: "#f9fafb",
          fontSize: 13,
          outline: "none",
        }}
      />
    </div>
  );
}
